import React, { useState } from 'react'
import { Button, DatePicker } from 'antd'

const Datepicker = ({ loading, onSubmit }) => {
  const [dateRange, setDateRange] = useState([])
  const isValidRange = dateRange.length && dateRange.every((date) => !!date)

  return (
    <div className="datepicker">
      <DatePicker.RangePicker
        onCalendarChange={(_dates, dateStrings) => {
          setDateRange(dateStrings)
        }}
      />
      <Button
        type="primary"
        className="get-invoices"
        disabled={!isValidRange}
        loading={loading}
        onClick={() => {
          onSubmit(dateRange)
        }}
      >
        Søk
      </Button>
    </div>
  )
}

export default Datepicker
